// extracted by mini-css-extract-plugin
export var dropdownContainer = "_op-0";
export var leftAlign = "_op-4";
export var listItem = "_op-2";
export var listItemWrapper = "_op-1";
export var operationText = "_op-3";